import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f455face")

_pushScopeId("data-v-f455face")
const _hoisted_1 = { class: "login" }
const _hoisted_2 = {
  class: "display-3",
  style: {"text-align":"center"},
  id: "aviso-entorno"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", {
  class: "d-inline tituloHeader",
  style: {"text-align":"center"}
}, "SRP", -1)
const _hoisted_4 = { class: "form-floating" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { for: "email" }, "Correo", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "invalid-feedback" }, "Ingresa un correo válido.", -1)
const _hoisted_7 = { class: "form-floating" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { for: "password" }, "Contraseña", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "invalid-feedback" }, "Ingresa una contraseña.", -1)
const _hoisted_10 = {
  key: 0,
  class: "error"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("¿Olvidaste tu contraseña?")
const _hoisted_12 = { class: "d-grid" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_BotonPrimario = _resolveComponent("BotonPrimario")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.aviso), 1),
    _createVNode("form", {
      action: "",
      class: ["form", { 'was-validated': _ctx.formularioValidado }],
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"])),
      novalidate: "",
      ref: "formulario"
    }, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _withDirectives(_createVNode("input", {
          type: "email",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
          class: "form-control",
          id: "email",
          placeholder: "usuario@hircasa.com.mx",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.email]
        ]),
        _hoisted_5,
        _hoisted_6
      ]),
      _createVNode("div", _hoisted_7, [
        _withDirectives(_createVNode("input", {
          type: "password",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
          class: "form-control",
          id: "password",
          placeholder: "Contraseña",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.password]
        ]),
        _hoisted_8,
        _hoisted_9
      ]),
      (_ctx.error)
        ? (_openBlock(), _createBlock("p", _hoisted_10, "Has introducido mal el email o la contraseña."))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: { name: 'srp-recuperar-contrasena', query: _ctx.email ? { email: _ctx.email } : {} },
        style: {"text-align":"right"},
        class: "mt-2"
      }, {
        default: _withId(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_BotonPrimario, {
          cargando: _ctx.estaCargandoIniciar,
          icono: "fas fa-chevron-right",
          color: "btn-primary text-white",
          texto: "Iniciar",
          mensaje: "Iniciando",
          class: "BotonPrimario"
        }, null, 8, ["cargando"])
      ])
    ], 34)
  ]))
})